import { Avatar, Box, Chip, Typography } from "@mui/material";
import { FaCheck } from "react-icons/fa";
import {
  AppliedTaxes,
  typeTaxKeys,
} from "../../../../types/budget/service-item";
import { AuthContext } from "../../../../contexts/auth";
import { useContext, useMemo } from "react";
import {
  BudgetItemType,
  CalcOption,
  editBitributedRoles,
} from "../../../../types/budget/budget";
import { useBudget } from "../../../../contexts/BudgetContext/projectbudgets.context";
import {
  APPLIED_TAX_PILL_KEYS,
  isAppliedTaxPillVisible,
} from "../../../../utils/appliedTaxesByCurrency";

type Props = {
  calcOption: CalcOption;
  category: BudgetItemType;
  supplierId: string;
  /** Moeda do câmbio da categoria (baseValue), alinhada ao bloco Valores */
  exchangeCurrency: string;
  eventScope?: string;
};

const AppliedTaxesComponent: React.FC<Props> = ({
  calcOption,
  category,
  supplierId,
  exchangeCurrency,
  eventScope,
}: Props) => {
  const { activeBudgetDispatch, activeBudget, versionInfo, isBudgetDisabled } =
    useBudget();

  const mainAppliedTaxes = useMemo(() => {
    return activeBudget?.mainAppliedTaxes?.find(
      (el) =>
        el.supplierId === supplierId &&
        el.category === category &&
        el.calcOption === calcOption &&
        el.version === versionInfo.version
    );
  }, [activeBudget, supplierId, category, calcOption, versionInfo]);
  const { userRoleName } = useContext(AuthContext);
  const canEditBiTributed = editBitributedRoles.includes(userRoleName);
  function handleStateChange(appliedTaxesList: AppliedTaxes) {
    // Verifica se o valor realmente mudou antes de disparar o dispatch
    if (JSON.stringify(mainAppliedTaxes?.appliedTaxes) === JSON.stringify(appliedTaxesList)) {
      return;
    }
    activeBudgetDispatch({
      type: "UPDATE_MAIN_APPLIED_TAXES",
      payload: { ...mainAppliedTaxes, appliedTaxes: appliedTaxesList },
      versionInfo,
    });
  }
  return (
    <Box
      gap={1}
      display={"flex"}
      flexDirection={"column"}
      border={1}
      borderColor="#ddd"
      borderRadius={3}
      p={1}
    >
      <Box>
        <Typography variant="body1" fontWeight={600}>
          Taxas padrão
        </Typography>
        <Typography variant="body2" sx={{ color: "#666" }}>
          As taxas selecionadas abaixo serão aplicadas por padrão em todos os
          serviços, exceto quando sofrerem alteração manual em um serviço
          específico.
        </Typography>
      </Box>
      <Box gap={1} display={"flex"} sx={{ flexWrap: "wrap" }}>
        {typeof mainAppliedTaxes === "object" &&
          APPLIED_TAX_PILL_KEYS.filter(
            (key) =>
              (canEditBiTributed || key !== "doubleCharged") &&
              isAppliedTaxPillVisible(key, exchangeCurrency, eventScope),
          ).map((key) => {
            const value = Boolean(mainAppliedTaxes.appliedTaxes[key]);
            return (
              <Chip
                key={key}
                variant="outlined"
                onClick={() => {
                  return handleStateChange({
                    ...mainAppliedTaxes.appliedTaxes,
                    [key]: !value,
                  });
                }}
                sx={{ fontSize: "12px" }}
                avatar={
                  <Avatar sx={{ background: "#F1F2F3" }} variant="circular">
                    {value ? <FaCheck color="#1361A4" /> : " "}
                  </Avatar>
                }
                label={typeTaxKeys[key]}
                disabled={isBudgetDisabled}
              />
            );
          })}
      </Box>
    </Box>
  );
};

export default AppliedTaxesComponent;
